import { isDevOrPreviewSite } from '../../utils/general'
import {
  F_API_KEY,
  F_CUSTOM_DOMAIN,
  F_EDIT_MODE,
  F_EMAIL_GATE,
  F_PWD_PROTECTION,
  F_FEEDBACK_MODE,
  F_PRESENTATION_MODE,
  F_MINIMALIST_MODE,
  F_TRACKED_LINKS,
  F_PDF_PAGE_ANALYTICS,
  F_DOWNLOAD_ANALYTICS,
  F_PDF_TO_WEBSITE,
  F_EMAIL_WHITELIST
} from './constants'

const isDev = isDevOrPreviewSite()

const MAX_PLAN = {
  id: isDev ? 'prod_StOfjvclPrF0J6' : 'prod_StOP6NMUyjkTFY',
  label: 'Pro Max',
  prices: {
    yearly: {
      stripe: {
        usd: {
          symbol: '$',
          value: 888,
          priceId: isDev ? 'price_1RxbsSKnX1nnNv6IUZDLC8dB' : 'price_1SOga5KnX1nnNv6I6JTNUVcz'
        },
        eur: {
          symbol: '€',
          value: 888,
          priceId: isDev ? 'price_1RxbsuKnX1nnNv6Ip0D4bigk' : 'price_1SOgagKnX1nnNv6IXUereix5'
        },
        gbp: {
          symbol: '£',
          value: 672,
          priceId: isDev ? 'price_1RxbtqKnX1nnNv6IslOjxSrf' : 'price_1RxbnxKnX1nnNv6IlNTjYch9'
        },
        inr: {
          symbol: '₹',
          value: 51000,
          priceId: isDev ? 'price_1TjdsaKnX1nnNv6IjMrGD8LX' : 'price_1TjdhuKnX1nnNv6I9scK1yHu'
        }
      },
      paddle: { priceId: isDev ? 'pri_01kb25s4ervqgmthjyamtc9pdd' : 'pri_01kerz8trcjr6etssrwfzx2e95' },
      payPro: { priceId: isDev ? 134667 : 134668 }
    },
    monthly: {
      stripe: {
        usd: {
          symbol: '$',
          value: 89,
          priceId: isDev ? 'price_1RxbsCKnX1nnNv6InqYLM5VN' : 'price_1SOgWFKnX1nnNv6IfhOlDyxi'
        },
        eur: {
          symbol: '€',
          value: 89,
          priceId: isDev ? 'price_1RxbsdKnX1nnNv6ICK1vtoq6' : 'price_1SOgWPKnX1nnNv6I7EWkysn7'
        },
        gbp: {
          symbol: '£',
          value: 68,
          priceId: isDev ? 'price_1RxbtfKnX1nnNv6I6lhh9ZqW' : 'price_1SOgTrKnX1nnNv6InVIHTkMq'
        },
        inr: {
          symbol: '₹',
          value: 5200,
          priceId: isDev ? 'price_1Tjdt9KnX1nnNv6I3DGtBwEh' : 'price_1TjdhGKnX1nnNv6Izb0JSetw'
        }
      },
      paddle: { priceId: isDev ? 'pri_01kb25qkhqr77n74xrfepn47gf' : 'pri_01kerz7qeapa7jtj6mt1j6ms30' },
      payPro: { priceId: isDev ? 134670 : 134669 }
    }
  },
  fileSizeLimit: 2000000,
  customDomainsLimit: 5,
  projectLimit: 999,
  accountLimit: 2000000,
  visitorLimit: 500000,
  bandwidthLimit: 100,
  features: {
    [F_CUSTOM_DOMAIN]: true,
    [F_PWD_PROTECTION]: true,
    [F_EDIT_MODE]: true,
    [F_API_KEY]: true,
    [F_EMAIL_GATE]: true,
    [F_FEEDBACK_MODE]: true,
    [F_PRESENTATION_MODE]: true,
    [F_MINIMALIST_MODE]: true,
    [F_TRACKED_LINKS]: true,
    [F_PDF_PAGE_ANALYTICS]: true,
    [F_DOWNLOAD_ANALYTICS]: true,
    [F_PDF_TO_WEBSITE]: true,
    [F_EMAIL_WHITELIST]: true
  }
}

export default MAX_PLAN
